import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {Subcategory} from '../models';

@Injectable()
export class SubcategoryService extends IoService {
  protected model = Subcategory;
  protected listUrl = '/subcategories/';
}
